import {
  DriveIcon,
  ChecklistIcon,
  FilialsIcon,
  MailIcon,
  ShieldIcon,
  UsersIcon,
  TimezonesIcon,
  BellIcon,
  BellCogIcon
} from '@assets/icons';
import { ROUTES } from '@/containers/routes/constants';
import { INavbarMenu } from '@/mock-data/navbar-menu';
import { useTranslation } from 'react-i18next';

export const useGetNavMenuItems = (isSaaSProduct: boolean) => {
  const { t } = useTranslation();
  const editProfileNavItems: INavbarMenu[] = [
    {
      label: t('profile.personalData'),
      icon: UsersIcon,
      value: ROUTES.profile.pages.personalData
    },
    { label: t('profile.company'), icon: FilialsIcon, value: ROUTES.profile.pages.filials },
    { label: t('profile.safety'), icon: ShieldIcon, value: ROUTES.profile.pages.safety },
    {
      label: t('profile.emailAccount'),
      icon: MailIcon,
      value: ROUTES.profile.pages.mailAccount
    },
    { label: t('filials.diskSpace.disk'), icon: DriveIcon, value: ROUTES.profile.pages.disk },
    { label: t('profile.locale'), icon: TimezonesIcon, value: ROUTES.profile.pages.locale },
    {
      label: t('profile.notifications'),
      icon: BellIcon,
      value: ROUTES.profile.pages.notifications
    },
    {
      label: t('profile.notificationSettings'),
      icon: BellCogIcon,
      value: ROUTES.profile.pages.notificationSettings
    }
  ];
  if (isSaaSProduct) {
    editProfileNavItems.push({
      label: t('license.licenses'),
      icon: ChecklistIcon,
      value: ROUTES.profile.pages.licenses
    });
  }
  return { editProfileNavItems };
};
